<template>
  <b-card-group>
    <b-card no-body>
      <b-collapse visible id="filterCollapse">
        <div class="card-body">
          <div>
            <b-form>
              <b-row>
                <b-col cols="1">
                  <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                    <font-awesome-icon icon="times" />
                    {{ $t('Сброс') }}
                  </b-button>
                </b-col>
                <filter-select
                  :label="$t('Тип организации')"
                  v-model="form.group"
                  :options="groups"
                  v-on:onChange="search"
                ></filter-select>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </b-card-group>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';

export default {
  name: 'filter-form',
  extends: BaseFilter,
  props: {
    group: String,
  },
  data() {
    return {
      form: {
        group: this.group || '',
      },
      groups: [],
    };
  },
  created() {
    this.addEventListener();
    this.loadGroups();
  },
  methods: {
    loadGroups() {
      axios
        .get('/Dictionary/GetGroups')
        .then((response) => {
          this.groups = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
